import { LoadingMaskService } from '../../core/services/loading-mask.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-loading-mask',
  templateUrl: './loading-mask.component.html',
  styleUrls: ['./loading-mask.component.scss'],
  standalone: true,
  imports: [CommonModule],
})
export class LoadingMaskComponent implements OnInit {
  constructor(public loadingMaskService: LoadingMaskService) {}

  ngOnInit() {}
}
